<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div class="d-flex">
    <div class="pa-4 white">
      <v-img
        :aspect-ratio="1"
        :src="'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='+data"
        :width="size"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrCodeDisplay',
  props: {

    data: {},
    size: {}
  }
}
</script>

<style scoped>

</style>
